import React from 'react';
import { FaVideo, FaWhatsapp } from 'react-icons/fa';

export default function BotonVideollamadaFlotante() {
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col space-y-3">
      {/* Botón de WhatsApp */}
      <div className="group relative">
        <div className="opacity-0 group-hover:opacity-100 transform scale-95 group-hover:scale-100 -translate-x-2 group-hover:translate-x-0 transition-all duration-300 bg-white text-[#1C1C1C] text-xs px-3 py-1 rounded shadow pointer-events-none whitespace-nowrap absolute right-full mr-2 top-1/2 -translate-y-1/2">
          Contactar por WhatsApp
        </div>
        <a
          href="https://wa.me/5492616388375"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-green-500 text-white p-4 rounded-full shadow-lg hover:bg-green-600 transition-colors flex items-center justify-center"
          aria-label="Contactar por WhatsApp"
        >
          <FaWhatsapp className="text-xl" />
        </a>
      </div>

      {/* Botón de Videollamada */}
      <div className="group relative">
        <div className="opacity-0 group-hover:opacity-100 transform scale-95 group-hover:scale-100 -translate-x-2 group-hover:translate-x-0 transition-all duration-300 bg-white text-[#1C1C1C] text-xs px-3 py-1 rounded shadow pointer-events-none whitespace-nowrap absolute right-full mr-2 top-1/2 -translate-y-1/2">
          Coordinar videollamada
        </div>
        <a
          href="https://wa.me/5492616388375?text=¡Hola! Quisiera coordinar una videollamada para planificar mi próximo viaje"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-[#B49A56] text-white p-4 rounded-full shadow-lg hover:bg-[#9e844f] transition-colors flex items-center justify-center"
          aria-label="Coordiná videollamada"
        >
          <FaVideo className="text-xl" />
        </a>
      </div>
    </div>
  );
}